import Vue from 'vue'
import Router from 'vue-router'
import result from '@/components/example01/result'
import example01 from '@/components/example01/index'
import judgetrue from '@/components/example01/judgetrue'
import judgefalse from '@/components/example01/judgefalse'
import tip from '@/components/example01/tip'
import tipresult from '@/components/example01/tipresult'
import explain from '@/components/example01/explain'
import video from '@/components/example01/video'
import callback from '@/components/example01/callback'
import explain2 from '@/components/example01/explain2'
import FaultReport from '@/pages/faultReport'
import DefaultPage from '@/pages/default'
import MainPage from '@/pages/main/index'
import Y2wm from '@/pages/y2wm/index'
import Wk from '@/pages/wk/index'
import Identify from '@/components/scanQR/identify'
import Identify2 from '@/components/scanQR/identify2'
import Quotation from '@/pages/quotation/index'
import Quotation2 from '@/pages/quotation2/index'
import QuotationItem from '@/pages/quotation2/quotation-item'
import Quotation2Result from '@/pages/quotation2/quotation-result'
import ParamsManager from '@/pages/quotation2/params-manager'
import QuotationResult from '@/pages/quotation/result'
import CodeGroup from '@/pages/codeGroup/index'
import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/main',
      name: 'main',
      component: MainPage
    }, {
      path: '/:company/:code',
      name: 'defaultPage',
      component: DefaultPage
    }, {
      path: '/jt',
      name: 'judgetrue',
      component: judgetrue
    }, {
      path: '/jf',
      name: 'judgefalse',
      component: judgefalse
    }, {
      path: '/tip',
      name: 'tip',
      component: tip
    }, {
      path: '/tipresult',
      name: 'tipresult',
      component: tipresult
    }, {
      path: '/explain',
      name: 'explain',
      component: explain
    }, {
      path: '/explain2',
      name: 'explain2',
      component: explain2
    }, {
      path: '/callback',
      name: 'callback',
      component: callback
    }, {
      path: '/faultReport',
      name: 'faultReport',
      component: FaultReport
    }, {
      path: '/y2wm',
      name: 'y2wm',
      component: Y2wm
    }, {
      path: '/y2wm1',
      name: 'y2wm1',
      component: Y2wm
    }, {
      path: '/y2wm2',
      name: 'y2wm2',
      component: Y2wm
    }, {
      path: '/y2wm3',
      name: 'y2wm3',
      component: Y2wm
    }, {
      path: '/wk',
      name: 'wk',
      component: Wk
    }, {
      path: '/identify',
      name: 'identify',
      component: Identify2
    },{
      path: '/identify2',
      name: 'identify2',
      component: Identify2
    }, {
      path: '/quotation',
      name: 'quotation',
      component: Quotation
    }, {
      path: '/quotationresult',
      name: 'quotationresult',
      component: QuotationResult
    },{
      path: '/params-manager',
      name: 'params-manager',
      component: ParamsManager
    }, {
      path: '/quotation2',
      name: 'quotation2',
      component: Quotation2
    }, {
      path: '/quotation-item',
      name: 'quotationItem',
      component: QuotationItem
    }, {
      path: '/quotation2-result',
      name: 'quotation2Result',
      component: Quotation2Result
    }, {
      path: '/codeGroup',
      name: 'codeGroup',
      component: CodeGroup
    }, {
      path: '/:company',
      name: 'defaultPage2',
      component: DefaultPage
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title; // 设置页面标题

  }
  // document.title = store.getters.applet.name
  next(); // 必须调用next()来resolve这个钩子
});


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js